import { useEffect, useState } from 'react';
import { phone, phoneHref, whatsappHref } from '../data';

const NAV_LINKS = [
  { label: 'Collections', href: '#collections' },
  { label: 'Sarees', href: '#sarees' },
  { label: 'Men\u2019s Wear', href: '#menswear' },
  { label: 'Our Story', href: '#story' },
  { label: 'Market', href: '#market' },
  { label: 'Gallery', href: '#gallery' },
  { label: 'Contact', href: '#contact' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  return (
    <>
      {/* Announcement bar */}
      <div className="bg-primary-500 text-background-50">
        <p className="mx-auto max-w-7xl px-4 md:px-6 py-2 text-center text-[11px] md:text-xs font-medium tracking-wide">
          Traditional Indian Textiles <span className="mx-1 opacity-60">•</span> Serving Customers Across the UK
        </p>
      </div>

      {/* Header */}
      <header
        className={`sticky top-0 z-40 transition-all duration-300 ${
          scrolled ? 'bg-background-50/95 shadow-[0_1px_0_0_oklch(var(--background-200))] backdrop-blur' : 'bg-transparent'
        }`}
      >
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 md:px-6 py-3.5 md:py-4">
          {/* Wordmark */}
          <a href="#top" className="flex flex-col leading-none">
            <span className="font-heading text-2xl md:text-[26px] font-semibold tracking-[0.06em] text-foreground-950">
              SRM TEXTILES
            </span>
          </a>

          {/* Desktop nav */}
          <nav className="hidden lg:flex items-center gap-8" aria-label="Primary">
            {NAV_LINKS.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-[13px] font-medium text-foreground-700 transition-colors hover:text-primary-500"
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* Desktop contact CTA */}
          <div className="hidden lg:flex items-center gap-3">
            <a
              href={phoneHref}
              className="inline-flex whitespace-nowrap items-center gap-2 rounded-md bg-primary-500 px-4 py-2.5 text-[13px] font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-phone-line" aria-hidden="true" />
              Call {phone}
            </a>
            <a
              href={whatsappHref}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex whitespace-nowrap h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
              aria-label="WhatsApp SRM Textiles"
            >
              <i className="ri-whatsapp-line" aria-hidden="true" />
            </a>
          </div>

          {/* Mobile toggle */}
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden inline-flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-900"
            aria-label={open ? 'Close menu' : 'Open menu'}
            aria-expanded={open}
          >
            <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-xl`} aria-hidden="true" />
          </button>
        </div>

        {/* Mobile menu */}
        {open && (
          <div className="lg:hidden fixed inset-x-0 top-[104px] bottom-0 z-40 bg-background-50 overflow-y-auto">
            <nav className="flex flex-col px-4 md:px-6 py-6 gap-1" aria-label="Mobile">
              {NAV_LINKS.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  onClick={() => setOpen(false)}
                  className="border-b border-background-200 py-4 font-heading text-2xl text-foreground-900"
                >
                  {link.label}
                </a>
              ))}
              <div className="mt-6 grid grid-cols-2 gap-3">
                <a
                  href={phoneHref}
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-sm font-semibold text-background-50"
                >
                  <i className="ri-phone-line" aria-hidden="true" />
                  Call
                </a>
                <a
                  href={whatsappHref}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-200 px-4 py-3 text-sm font-semibold text-foreground-800"
                >
                  <i className="ri-whatsapp-line" aria-hidden="true" />
                  WhatsApp
                </a>
              </div>
            </nav>
          </div>
        )}
      </header>

      {/* Sticky mobile contact action */}
      <div className="lg:hidden fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 gap-px bg-background-200">
        <a
          href={phoneHref}
          className="flex items-center justify-center gap-2 whitespace-nowrap bg-primary-500 py-3 text-[13px] font-semibold text-background-50"
        >
          <i className="ri-phone-line" aria-hidden="true" />
          Call SRM Textiles
        </a>
        <a
          href={whatsappHref}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 whitespace-nowrap bg-foreground-950 py-3 text-[13px] font-semibold text-background-50"
        >
          <i className="ri-whatsapp-line" aria-hidden="true" />
          WhatsApp Us
        </a>
      </div>
    </>
  );
}